import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";

export const fetchReportFormat = createAsyncThunk(
  "reportSettings/fetchReportFormat",
  async () => {
    const response = await axiosInstance.get("api/report-settings");
    return response.data; // { format }
  }
);

// export const updateReportFormat = createAsyncThunk(
//   "reportSettings/updateReportFormat",
//   async (format) => {
//     const response = await axiosInstance.put("api/report-settings", {
//       format,
//     });
//     return response.data; // { format }
//   }
// );
export const updateReportFormat = createAsyncThunk(
  "reportSettings/updateReportFormat",
  async (payload) => { // CHANGED: accepts { format, minYear } instead of just format
    const response = await axiosInstance.put("api/report-settings", payload);
    return response.data;
  }
);


const reportSettingsSlice = createSlice({
  name: "reportSettings",
  initialState: {
    format: "yearFilter",
    minYear: 1990, // default until fetched
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportFormat.fulfilled, (state, action) => {
        state.format = action.payload.format;
         state.minYear = action.payload.minYear; 
      })
      .addCase(updateReportFormat.fulfilled, (state, action) => {
        state.format = action.payload.format;
          state.minYear = action.payload.minYear;
      });
  },
});

export default reportSettingsSlice.reducer;